import React, { useEffect, useState, createContext, useContext } from 'react';
import { useUserContext } from '../user_context/UserContext';
import { getGlobalDocuments } from '../../repository/GeneralDocumentsDAO';
import { UserStatus } from '../../components/routes/routing_statuses/RoutingStatuses';

export const GeneralDocumentContext = createContext();

export const GeneralDocumentProvider = ({ children }) => {
    const { firebaseUser } = useUserContext();
    const [roles, setRoles] = useState(null); // Default to null

    // useEffect(() => {    
    //     if (firebaseUser && firebaseUser !== UserStatus.FIREBASE_USER_DOES_NOT_EXIST && firebaseUser !== UserStatus.UNINITIALIZED) {
    //         (async () => {
    //             try {
    //                 const fetchedGlobalDocuments = await getGlobalDocuments();
    //                 const globalData = fetchedGlobalDocuments.data();
    //                 setRoles(globalData.roles);
    //             } catch (error) {
    //                 console.error('Error fetching global documents:', error);
    //                 setRoles(null);
    //             }
    //         })();      
    //     } else {
    //         setRoles(null);
    //     }
    // }, [firebaseUser]);

    const resetGeneralDocumentContext = () => {
        setRoles(null); // Reset to null
    };

    return (
        <GeneralDocumentContext.Provider
            value={{
                roles,
                resetGeneralDocumentContext
            }}
        >
            {children}
        </GeneralDocumentContext.Provider>
    );
};

export const useGeneralDocumentContext = () => {
    return useContext(GeneralDocumentContext);
};
